export enum WarrantyStatus {
    Active = 'Active',
    TimeExpired = 'Time expired',
    MilesExpired = 'Miles expired',
    Expired = 'Expired'
}
